import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const DEBOUNCE_MS = 400;

// Único punto de debounce de la búsqueda (contrato §0 "Cancelar peticiones. Con debounce de
// 400 ms..."). BuscarPage no debe añadir un segundo debounce: reacciona directamente a los
// cambios de `urlState.text`, que ya llegan espaciados desde aquí.
const SearchInput = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [text, setText] = useState(value || "");
  const timeoutRef = useRef(null);

  useEffect(() => {
    setText(value || "");
  }, [value]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const handleChange = (e) => {
    const next = e.target.value;
    setText(next);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onChange(next), DEBOUNCE_MS);
  };

  return (
    <div className="bq-search-input">
      <svg width="22" height="22" viewBox="0 0 24 24" className="bq-icon" aria-hidden="true">
        <circle cx="10.5" cy="10.5" r="7" />
        <line x1="15.5" y1="15.5" x2="21" y2="21" />
      </svg>
      <input
        type="text"
        aria-label={t("search.open.aria")}
        placeholder={t("search.buscar.placeholder")}
        value={text}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
